/**
 * Route Constants
 * Centralized route definitions for the application
 */

export const PUBLIC_ROUTES = {
  LANDING: "/",
  PRIVACY_POLICY: "/privacy-policy",
  COOKIE_POLICY: "/cookie-policy",
  TERMS_CONDITIONS: "/terms-and-conditions",
};

export const AUTH_ROUTES = {
  LOGIN: "/login",
  RECOVER_PASSWORD: "/recover-password",
  TWO_FACTOR_AUTH: "/two-factor-auth",
};
